import { ENetwork } from 'web3';

/**
 * Smart contract addresses for different networks
 */
export const CONTRACTS = {
  [ENetwork.bsc]: {
    /**
     * PancakeSwap Infinite CL Pool Manager Contract
     * @see https://bscscan.com/address/0xa0FfB9c1CE1Fe56963B0321B32E7A0302114058b
     */
    PANCAKE_POOL_MANAGER: '0xa0FfB9c1CE1Fe56963B0321B32E7A0302114058b' as const,
  },
} as const;
